//
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
    },
    {
        text: 'folio',
        value: 'folio',
    },
    {
        text: 'rut',
        value: ({ pch_provider }) => pch_provider.rut,
        format: 'rut',
    },
    {
        text: 'proveedor',
        value: ({ pch_provider }) => pch_provider.business_name,
        component: {
            custom: 'pch_provider_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'provider-update',
                    params: {
                        id: value,
                    },
                }),
                tooltip: 'Detalle proveedor',
            },
        },
    },
    {
        text: 'tipo',
        value: 'document_type',
        align: 'center',
        sortable: true,
        component: {
            type: 'chip-label',
            props: {
                colors: {
                    factura: 'secondary lighten-3',
                    nota_de_crédito: 'accent lighten-3',
                    nota_de_débito: 'brown lighten-3',
                },
                small: true,
            },
        },
    },
    {
        text: 'vencimiento',
        value: 'payment_date',
        align: 'right',
        format: 'date',
        sortable: true,
    },
    {
        text: 'total',
        value: 'total',
        align: 'right',
        format: 'currency',
        sortable: true,
    },
    {
        text: 'fecha contable',
        value: 'accounting_date',
        align: 'right',
        format: 'date',
        sortable: true,
    },
    {
        text: 'modificación',
        value: 'updated_at',
        align: 'right',
        format: 'datetime',
        sortable: true,
    },
]
